/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Gpx_Import_Failed_OneInputs */

const en_toast_gpx_import_failed_one = /** @type {(inputs: Toast_Gpx_Import_Failed_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} route failed to import`)
};

const de_toast_gpx_import_failed_one = /** @type {(inputs: Toast_Gpx_Import_Failed_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Route konnte nicht importiert werden`)
};

/**
* | output |
* | --- |
* | "{count} route failed to import" |
*
* @param {Toast_Gpx_Import_Failed_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_gpx_import_failed_one = /** @type {((inputs: Toast_Gpx_Import_Failed_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Gpx_Import_Failed_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_gpx_import_failed_one(inputs)
	return de_toast_gpx_import_failed_one(inputs)
});